<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "termComments",
  data() {
    return {};
  },
  created() {}
};
</script>
